import { BLOCK_CLASSES } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
import { stylable } from '../decorators';
export const horizontalRuleSpec = stylable({
  content: '',
  group: 'block',
  attrs: {
    type: {
      default: 'horizontalRule'
    },
    width: {
      default: ''
    }
  },
  parseDOM: [{
    tag: 'hr'
  }],
  toDOM(_node) {
    return ['div', {
      class: `${BLOCK_CLASSES.divider} intercom-divider-container`
    }, ['div', ['hr']]];
  }
});